const nonCoveredDriverVehicleDisclosure =
  <>If the driver or vehicle involved in the loss is NOT a covered driver or vehicle on your policy, please call <a href="tel:18005352873">800-535-2873</a> to report your claim.</>;

const getDisclosureAgreementText = (state) => {
  switch (state) {
    case "MI":
    case "Michigan":
      return (
        <>
          The Michigan Department of Insurance and Financial Services defines insurance fraud as providing “false information to an insurance company 
          in order to gain something of value that he or she would not have received if the truth had been told[.]” Under Michigan law, it is unlawful to present 
          to any insurer or agent thereof any oral or written statement knowing that the statement contains any false information concerning any fact material to 
          an application for the issuance of an insurance policy or a claim.
        </>
      );
    case "NJ":
    case "New Jersey":
      return (
        <>
          Pursuant to New Jersey regulations, “Any person who knowingly files a statement of claim containing any false or misleading information is 
          subject to criminal and civil penalties."       
        </>
      );
    case "PA":
    case "Pennsylvania":
      return (
        <>
          Pursuant to Pennsylvania regulations, “Any person who knowingly and with intent to defraud any insurance company or other person files an 
          application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information 
          concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.”
        </>
      );
    default:
      return `No Disclosure Agreement found for the state of ${state}`;
  }
};

export { getDisclosureAgreementText, nonCoveredDriverVehicleDisclosure };
